import { call, put } from 'redux-saga/effects';
import axios from 'src/api/Api';
import {
    GET_REJECT_SET_REASONS_SUCCESS,
    GET_REJECT_SET_REASONS_FAILURE,
} from '../actions';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getRejectSetReasons() {
    const baseSiteId = localStorage.getItem('baseSiteId') || 'defaultSite';
    const url = `/occ/v2/${baseSiteId}/dashboard/getDashboardPreference`;

    try {
        const { data } = yield call(axios.get, url);
        const rejectSetDetails = data?.rejectSetDetails || [];
        const rejectReasons = rejectSetDetails
            .map((reason) => ({
                value: reason?.reasonCode,
                label: reason?.reasonDetails,
            }))
            .filter((reason) => reason.value && reason.label);

        yield put({
            type: GET_REJECT_SET_REASONS_SUCCESS,
            payload: rejectReasons,
        });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({
            type: GET_REJECT_SET_REASONS_FAILURE,
            payload: error,
        });
    }
}
